import { TitleText } from "./style";

type TitleProps = {
  text: string;
};

export default function Title({ text }: TitleProps) {
  return <TitleText>{text}</TitleText>;
}
